"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _reactTransitionGroup = require("react-transition-group");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var forwardSlideEntrance = (0, _styledComponents.keyframes)(["from{transform:translate3d(100%,0,0);}to{transform:translate3d(0,0,0);}"]);
var forwardSlideExit = (0, _styledComponents.keyframes)(["from{transform:translate3d(0,0,0);}to{transform:translate3d(-100%,0,0);}"]);
var backwardSlideEntrance = (0, _styledComponents.keyframes)(["from{transform:translate3d(-100%,0,0);}to{transform:translate3d(0,0,0);}"]);
var backwardSlideExit = (0, _styledComponents.keyframes)(["from{transform:translate3d(0,0,0);}to{transform:translate3d(100%,0,0);}"]);
var fadeIn = (0, _styledComponents.keyframes)(["from{opacity:0;}to{opacity:1;}"]);
var fadeOut = (0, _styledComponents.keyframes)(["from{opacity:1;}to{opacity:0;}"]);

var getAnimation = function getAnimation(direction, isExit, animation) {
  switch (animation) {
    case 'fade':
      if (isExit) {
        return fadeOut;
      }

      return fadeIn;

    case 'slide':
    default:
      if (direction === 'forward' && isExit) {
        return forwardSlideExit;
      }

      if (direction === 'forward') {
        return forwardSlideEntrance;
      }

      if (isExit) {
        return backwardSlideExit;
      }

      return backwardSlideEntrance;
  }
};

var Slide = _styledComponents.default.div.withConfig({
  displayName: "Transition__Slide",
  componentId: "uca24u-0"
})(["bottom:0;display:flex;left:0;overflow-y:auto;position:fixed;right:0;top:0;&.transition-enter-active{overflow-y:hidden;}&.transition-exit-active{overflow-y:hidden;}"]);

var AnimationWrapper = (0, _styledComponents.default)(_reactTransitionGroup.TransitionGroup).withConfig({
  displayName: "Transition__AnimationWrapper",
  componentId: "uca24u-1"
})(["& .transition-enter-active{animation:", " 0.5s cubic-bezier(0.445,0.05,0.55,0.95);}& .transition-exit-active{animation:", " 0.5s cubic-bezier(0.445,0.05,0.55,0.95);}"], function (_ref) {
  var direction = _ref.direction,
      animation = _ref.animation;
  return getAnimation(direction, false, animation);
}, function (_ref2) {
  var direction = _ref2.direction,
      animation = _ref2.animation;
  return getAnimation(direction, true, animation);
});

var Transition = function Transition(_ref3) {
  var children = _ref3.children,
      id = _ref3.id,
      direction = _ref3.direction,
      animation = _ref3.animation,
      className = _ref3.className;
  return id ? /*#__PURE__*/_react.default.createElement(AnimationWrapper, {
    className: className,
    direction: direction,
    animation: animation
  }, /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
    classNames: "transition",
    key: id,
    timeout: {
      enter: 470,
      exit: 470
    }
  }, /*#__PURE__*/_react.default.createElement(Slide, null, children))) : /*#__PURE__*/_react.default.createElement(_react.Fragment, null, children);
};

Transition.propTypes = {
  /* Which animation to run */
  animation: _propTypes.default.string,

  /* Children nodes of body */
  children: _propTypes.default.node,

  /** Custom class name to add to Transition. */
  className: _propTypes.default.string,

  /* Are you going forward or backward, default is forward */
  direction: _propTypes.default.string,

  /* Used for the CSS Transition Key */
  id: _propTypes.default.string
};
Transition.defaultProps = {
  animation: 'slide',
  direction: 'forward'
};
var _default = Transition;
exports.default = _default;
//# sourceMappingURL=Transition.js.map